import { useState } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

export default function Register() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleRegister = async (e) => {

    e.preventDefault();

    setMessage("Creating account...");

    try {

      const response = await fetch(API + "/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          password: password
        })
      });

      if (response.ok) {

        setMessage("Account created. Redirecting to login...");

        setTimeout(() => {
          window.location.href = "/login";
        }, 1500);

      } else {

        const data = await response.json();
        setMessage(data.detail || "Registration failed");

      }

    } catch (err) {

      setMessage("Server error");

    }

  };

  return (

    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "70vh"
    }}>

      <div style={{
        width: "320px",
        background: "white",
        padding: "30px",
        border: "1px solid #e8e6e3"
      }}>

        <h2 style={{ marginBottom: "20px" }}>
          Create Account
        </h2>

        <form onSubmit={handleRegister}>

          <input
            type="email"
            placeholder="Email"
            value={email}
            required
            onChange={e => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "15px"
            }}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={e => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "15px"
            }}
          />

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              cursor: "pointer"
            }}
          >
            Create Account
          </button>

        </form>

        <p style={{ marginTop: "15px" }}>
          {message}
        </p>

      </div>

    </div>

  );

}
